import React, {useMemo} from 'react';
import Pagination from "@/app/store/components/Pagination";

interface PaginationWrapperProps {
    isLoading: boolean;
    currentPage: number;
    lastPage: number;
    onPageChange: (page: number) => void;
}

/**
 * Reusable pagination wrapper component
 * Only renders if not loading and there's more than one page
 */
const PaginationWrapper: React.FC<PaginationWrapperProps> = (
    {
        isLoading,
        currentPage,
        lastPage,
        onPageChange
    }
) => {
    const shouldShowPagination = useMemo(
        () => !isLoading && lastPage > 1,
        [isLoading, lastPage]
    );

    if (!shouldShowPagination) {
        return null;
    }

    return (
        <Pagination
            currentPage={currentPage}
            lastPage={lastPage}
            onPageChange={onPageChange}
        />
    );
};

export default PaginationWrapper;